export default __webpack_public_path__ + "static/media/michelle.7b57ae90.jpg";